<template>
  <el-drawer
    title=""
    :visible.sync="drawerVisible"
    direction="ltr"
    :wrapperClosable="true"
    :close-on-press-escape="false"
    :show-close="false"
    :withHeader="false"
    size="86%"
    @close="closeDrawer"
    @open="drawerOpenHandle"
  >
    <div class="menu-box">
      <div class="book-info">
        <div class="book-pic-box">
          <img :src="basicData.cover">
        </div>
        <div class="book-txt">
          <h3 class="ellipsis-2" :title="basicData.title">
            {{ basicData.title }}
          </h3>
          <p v-if="basicData.judge">{{ basicData.judge }}</p>
          <p>{{ basicData.editor }}</p>
        </div>
      </div>
      <!-- <el-tree
        :data="navBarData"
        node-key="key"
        :default-expanded-keys="[2, 3]"
        :default-checked-keys="[5]"
        :props="defaultProps">
      </el-tree> -->
      <NavBar class="catalog-list" ref="navBar" :content="navBarData" @chapterChange="chapterChange"></NavBar>
    </div>
  </el-drawer>
</template>
<script>
  import NavBar from './navBar.vue'
  export default {
    name: "menuDrawer",
    components: {
      NavBar
    },
    props: {
      //drawer 是否展示
      visible: {
        type: Boolean,
        default: false,
      },
      basicData: {
        type: Object,
        default: () => {
          return {};
        }
      },
      navBarData: {
        type: Array,
        default: () => {
          return [];
        }
      },
    },
    data() {
      return {
        drawerVisible: false,
        activeIndex: '',
      }
    },
    watch: {
      visible(newVal) {
        this.drawerVisible = newVal
      }
    },
    methods: {
      chapterChange(index) {
        this.$emit('chapterChange', index)
        this.closeDrawer();
      },
      changeActiveIndex(activeIndex) {
        this.activeIndex = activeIndex
        if(this.$refs.navBar) {
          this.$refs.navBar.changeActiveIndex(activeIndex)
        }
      },
      drawerOpenHandle() {
        this.$nextTick(() => {
          this.$refs.navBar.changeActiveIndex(this.activeIndex)
        })
      },
      // 关闭弹窗
      closeDrawer() {
        this.$emit('closeDrawer', 'menu')
      },
    }
  }
</script>

<style scoped lang="scss">
.menu-box{
  width: 100%;
  height: 100%;
  overflow: hidden;
  display: flex;
  flex-direction: column;

  .book-info{
    width: 610rem;
    padding: 20rem 25rem;
    box-sizing: border-box;
    background: #F4F9FE;
    display: flex;
    align-items: center;
    position: relative;
    margin: 18rem auto 0;

    .book-pic-box {
      margin-right: 27rem;
      width: 139rem;
      height: 190rem;
      flex: 0 0 139rem;
      img {
        width: 100%;
      }
    }
    .book-txt{
      padding-bottom: 30rem;
      h3 {
        font-size: 32rem;
        line-height: 48rem;
        display: -webkit-box;
        overflow: hidden;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;
        font-weight: bold;
      }
      p {
        font-size: 24rem;
        line-height: 34rem;
        margin-top: 30rem;
      }
    }
  }

  .catalog-list{
    flex: 1;
    overflow: hidden;
    overflow-y: auto;
  }
}
/deep/.el-drawer {
  .el-drawer__body {
    padding: 0;
    padding-bottom: 128rem;
  }
}
/deep/.el-tree {
  padding: 0 20rem;
  margin-top: 20rem;

  .el-tree-node {
    padding: 17rem 0;

    
    &:hover,&:focus,&:active{
      .el-tree-node__content{
        background: #fff !important;
      }
    }

    .el-tree-node__content{
      background: #fff !important;
      
      &:hover,&:focus,&:active{
        background: #fff !important;
      }
    }

    .el-tree-node__label{
      font-size: 26rem;
      line-height: 36rem;
      color: #515151;
      white-space: pre-wrap;
    }
  }

  .el-tree-node.is-current{
    background: #fff !important;

    .el-tree-node__label{
      color: #0FC29A !important;
    }
  }
}
</style>